






























































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Toast } from "vant";

const retreatCouponModule = namespace("retreatCoupon");

@Component({
  components: {}
})
export default class FaceCouponsSure extends Vue {
  @retreatCouponModule.State("selectStep") active!: number;
  detailData: any = null;
  finished: boolean = false;
  loading: boolean = false;
  list: any = [];
  pages: any = {
    pageNum: 1,
    pageSize: 10,
    totalPage: 0
  };
  radioCoupon: any = null;
  defaultImg: any = require("@/image/default.png");
  mounted() {
    this.setActive();
    this.getDetails();
  }
  setActive() {
    this.$store.commit("retreatCoupon/setSelectStep", 2);
  }
  async getDetails() {
    const { error, success } = await this.$store.dispatch(
      "retreatCoupon/memberDetail",
      {
        searchText: this.$route.query.sancode,
        searchType: Number(this.$route.query.type)
      }
    );
    if (success && success.data) {
      this.detailData = success.data;
    }
  }
  getFaceCouponList() {
    if (this.pages.total > 0 && this.pages.total === this.list.length) {
      this.finished = true;
    }
    this.$store
      .dispatch("retreatCoupon/retreatCouponList", {
        pageNum: this.pages.pageNum,
        pageSize: this.pages.pageSize,
        cid: this.detailData
          ? this.detailData.customerCid
          : this.$route.query.sancode,
        writeOffBusinessEntityId: this.$global.tenantId
      })
      .then(res => {
        this.loading = false;
        if (res.success) {
          this.pages.totalPage = res.success.data.pages;
          if (!res.success.data.list) {
            this.finished = true;
            return;
          }
          this.list = [...this.list, ...res.success.data.list];
          this.list.map((item: any) => {
            item.couponEffectiveStartTime = this.$format(
              item.couponEffectiveStartTime,
              "YYYY.MM.DD"
            );
            item.couponEffectiveEndTime = this.$format(
              item.couponEffectiveEndTime,
              "YYYY.MM.DD"
            );
          });
          this.pages.pageNum++;
          console.log(this.pages.totalPage);
          if (this.pages.pageNum > this.pages.totalPage) {
            this.finished = true;
          }
          console.log(this.list);
        } else {
          this.finished = true;
        }
      });
  }
  onLoadList() {
    let self = this;
    setTimeout(() => {
      self.getFaceCouponList();
    }, 1000);

    // if(this.list){
    // this.getFaceCouponList(this.pages.pageNum + 1);
    // }
  }
  sureCoupon() {
    if (!this.radioCoupon) {
      (this as any).$dialog.alert({ message: "请选择已核销的优惠券" });
      return;
    }
    this.$router.push({
      path: `/retreatCoupon/sureRetreat`,
      query: {
        couponInstanceQrCode: this.radioCoupon.couponInstanceQrCode
      }
    });
  }
}
